var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_c('Modal', {
    attrs: {
      "width": "1000",
      "title": "计划时间"
    },
    on: {
      "on-ok": _vm.createPlanDate,
      "on-cancel": _vm.cancelPlanDate
    },
    model: {
      value: _vm.createPlanDateModal,
      callback: function ($$v) {
        _vm.createPlanDateModal = $$v;
      },
      expression: "createPlanDateModal"
    }
  }, [_c('div', {
    staticClass: "create-planDate-wrap"
  }, [_c('div', {
    staticClass: "create-planDate create-planDate-left"
  }, [_c('div', [_vm._v("计划出发")]), _c('div', {
    staticClass: "select-time"
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "type": "date",
      "format": "M-d",
      "placeholder": "请选择日期"
    },
    model: {
      value: _vm.departAtPlanDate,
      callback: function ($$v) {
        _vm.departAtPlanDate = $$v;
      },
      expression: "departAtPlanDate"
    }
  }), _c('TimePicker', {
    staticStyle: {
      "width": "112px"
    },
    attrs: {
      "format": "H:mm",
      "placeholder": "选择时间"
    },
    model: {
      value: _vm.departAtPlanTime,
      callback: function ($$v) {
        _vm.departAtPlanTime = $$v;
      },
      expression: "departAtPlanTime"
    }
  })], 1), _c('div', {
    staticClass: "option-cell-list",
    staticStyle: {
      "width": "100%",
      "margin-top": "20px"
    }
  }, _vm._l(_vm.dateOption, function (d, index) {
    return _c('div', {
      key: index,
      class: {
        'option-cell': true,
        selected: d.addDates === _vm.departAtPlanDateValue
      },
      on: {
        "click": function ($event) {
          return _vm.dateClick(d.addDates, 'departAtPlanDate');
        }
      }
    }, [_vm._v(_vm._s(d.name))]);
  }), 0), _c('div', {
    staticClass: "option-cell-list"
  }, _vm._l(_vm.timeOption, function (t, index) {
    return _c('div', {
      key: index,
      class: {
        'option-cell': true,
        selected: t.time === _vm.departAtPlanTime
      },
      on: {
        "click": function ($event) {
          return _vm.timeClick(t, 'departAtPlanTime');
        }
      }
    }, [_vm._v(_vm._s(t.time))]);
  }), 0)]), _c('div', {
    staticClass: "required-time"
  }, [_c('div', [_vm._v("需求时间")]), _c('h2', [_vm._v(_vm._s(_vm.modalNeedData))])])])]), _c('Modal', {
    attrs: {
      "title": "取消销售订单"
    },
    on: {
      "on-ok": function ($event) {
        return _vm.cancelOperate();
      },
      "on-cancel": function ($event) {
        _vm.cancelSalesOrderModal = false;
      }
    },
    model: {
      value: _vm.cancelSalesOrderModal,
      callback: function ($$v) {
        _vm.cancelSalesOrderModal = $$v;
      },
      expression: "cancelSalesOrderModal"
    }
  }, [_c('div', [_vm._v("取消" + _vm._s(_vm.cancaleSalesOrder ? _vm.cancaleSalesOrder.sales.abbr : "") + _vm._s(_vm.cancaleSalesOrder ? _vm.cancaleSalesOrder.volPlan : "") + "吨订单")]), _c('Form', {
    ref: "formItem",
    attrs: {
      "model": _vm.formItem,
      "label-width": 80
    },
    nativeOn: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "取消理由"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入取消销售订单的理由"
    },
    model: {
      value: _vm.formItem.canceledReason,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "canceledReason", $$v);
      },
      expression: "formItem.canceledReason"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "upper-panel"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('h2', [_vm._v("订单日期：")]), _c('Icon', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "md-arrow-dropleft",
      "size": "24"
    },
    on: {
      "click": function ($event) {
        return _vm.changeplanArrivedAt(null, null, '-');
      }
    }
  }), _c('DatePicker', {
    attrs: {
      "type": "date",
      "open": _vm.dateCalOpen,
      "options": _vm.planArrivedAtOptions
    },
    on: {
      "on-change": _vm.changeplanArrivedAt,
      "on-clickoutside": function ($event) {
        _vm.dateCalOpen = false;
      }
    }
  }, [_c('h1', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function ($event) {
        _vm.dateCalOpen = !_vm.dateCalOpen;
      }
    }
  }, [_vm._v(_vm._s(_vm.planArrivedAtDisplay))])]), _c('Icon', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "md-arrow-dropright",
      "size": "24"
    },
    on: {
      "click": function ($event) {
        return _vm.changeplanArrivedAt(null, null, '+');
      }
    }
  })], 1)]), _c('div', {
    staticClass: "lower-panel"
  }, _vm._l(_vm.factorySalesOrderList, function (f) {
    return _c('div', {
      key: f.factory._id,
      staticClass: "table-content",
      on: {
        "mousedown": function ($event) {
          return _vm.saveFactorySalesOrder(f);
        }
      }
    }, [_c('div', {
      staticClass: "section-header-wrapper"
    }, [_c('h3', [_vm._v(" " + _vm._s(f.factory.name) + " "), _c('span', {
      staticStyle: {
        "margin-left": "20px"
      }
    }, [_vm._v("合计" + _vm._s(_vm.calcSalesOrderVolPlan(f.salesOrder)) + "吨")])]), _c('div', {
      staticClass: "header-operate"
    }, [_c('span', [_vm._v("共" + _vm._s(f.salesOrder.length) + "条")]), _c('Button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function ($event) {
          return _vm.openAddNewSODrawer(f);
        }
      }
    }, [_vm._v("新增订单")])], 1)]), _c('Table', {
      ref: "SOTable",
      refInFor: true,
      attrs: {
        "loading": _vm.tableLoading,
        "columns": _vm.columns,
        "data": f.salesOrder,
        "row-class-name": _vm.rowClassName,
        "draggable": false,
        "border": ""
      },
      on: {
        "on-drag-drop": _vm.dragLine
      },
      scopedSlots: _vm._u([{
        key: "action",
        fn: function (_ref) {
          var row = _ref.row;
          return _vm.user.superAdmin || _vm.arrayIntersection(['sales', 'factoryLeader', 'deliveryLeader', 'deliveryAssist'], _vm.user.simpleRole).length > 0 ? [!row.startedAt ? _c('Button', {
            staticStyle: {
              "margin-right": "5px"
            },
            attrs: {
              "type": "primary",
              "size": "small",
              "ghost": ""
            },
            on: {
              "click": function ($event) {
                return _vm.$refs.SalesOrderReturnDrawer.openDrawer(row);
              }
            }
          }, [_vm._v("退货")]) : _vm._e(), !row.startedAt ? _c('Button', {
            attrs: {
              "type": "error",
              "size": "small",
              "ghost": ""
            },
            on: {
              "click": function ($event) {
                return _vm.cancel(row, f._id);
              }
            }
          }, [_vm._v("取消")]) : _vm._e()] : undefined;
        }
      }], null, true)
    })], 1);
  }), 0), _c('AddSalesOrderDrawer', {
    ref: "AddSalesOrderDrawer"
  }), _c('EditDeliveryDrawer', {
    ref: "EditDeliveryDrawer"
  }), _c('SalesOrderReturnDrawer', {
    ref: "SalesOrderReturnDrawer"
  }), _c('SODrawer', {
    ref: "SODrawer"
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }